import { IconButton, Typography } from "@mui/material";
import { FaChevronLeft } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";

import { useWhiteScreen } from "../../../../hooks/useWhiteScreen";
import { Container } from "../../../common/Container/Container";
import { NotFound } from "../../../common/NotFound/NotFound";
import { CourseCheckoutInformation } from "./components/CourseCheckoutInformation";
import {
	useCheckoutCourse,
	useCheckoutCourseInit,
} from "./hooks/useCheckoutCourse";

import "./checkout_course.scss";

export function CheckoutCourse() {
	const { isNotFound, isLoading } = useCheckoutCourseInit();
	const { course } = useCheckoutCourse();
	const navigate = useNavigate();
	useWhiteScreen();

	const onClickGoBack = () => {
		if (!course) {
			navigate("/");
			return;
		}

		navigate(-1);
	};

	if (isNotFound) {
		return <NotFound text="Course not found" />;
	}

	if (isLoading || !course) {
		return null;
	}

	return (
		<Container
			navbarOrkaProps={{ white: true }}
			className="checkout-course-container">
			<div className="header-container">
				<IconButton className="icon-button" onClick={onClickGoBack}>
					<FaChevronLeft />
				</IconButton>
				<Typography className="big-text bold">{course.name}</Typography>
			</div>
			<CourseCheckoutInformation />
		</Container>
	);
}
